import type { ComponentTypes } from 'api/types';

export const invisibleComponentTypes: ComponentTypes[] = [
  // Handoffs:
  'brand_embassy_chat_handoff',
  'drift_chat_handoff',
  'intercom_chat_handoff',
  'kustomer_chat_handoff',
  'salesforce_chat_handoff',
  'snapengage_chat_handoff',
  'zendesk_chat_handoff',
  'zendesk_messaging_handoff',
  'generic_handoff',
  'gorgias_chat_handoff',
  'talkdesk_chat_handoff',
  'freshchat_chat_handoff',
  'salesforce_messaging_handoff',
  'live_chat_chat_handoff',
  'ujet_chat_handoff',

  'csat_trigger_point',
  'end_interactive_email_chat',
  'knowledge_retrieval_stream',
  'autoflow_stream',
  'open_url',
  'trigger_event',
] as const;
